
export default {
  name: 'LayoutFooter',
  data() {
    return {
      solutionsSports: [],
      solutionsRoles: [],
      currentYear: new Date().getFullYear(),
    }
  },
  async fetch() {
    try {
      const menu = (
        await this.$prismic.api.getSingle('menu', {
          lang: this.$i18n.localeProperties.prismic,
        })
      ).data
 
      this.solutionsRoles = menu.solutions_roles
      this.solutionsSports = menu.solutions_sports
    } catch (error) {
      this.solutionsRoles = []
      this.solutionsSports = []
    }
  },
  watch: {
    '$i18n.locale': '$fetch',
  },
  fetchKey: 'menu',
}
